import React, { createContext, useContext, useState, useCallback } from 'react';
import { createPortal } from 'react-dom';
import './ConfirmDialog.scss';

const ConfirmDialogContext = createContext();

export const useConfirm = () => {
  const context = useContext(ConfirmDialogContext);
  if (!context) {
    throw new Error('useConfirm must be used within ConfirmDialogProvider');
  }
  return context;
};

export const ConfirmDialogProvider = ({ children }) => {
  const [dialog, setDialog] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null,
    confirmText: '確認',
    cancelText: '取消',
    type: 'danger' // 'danger' | 'warning' | 'info'
  });

  const confirm = useCallback((options) => {
    return new Promise((resolve) => {
      setDialog({
        isOpen: true,
        title: options.title || '確認操作',
        message: options.message,
        confirmText: options.confirmText || '確認',
        cancelText: options.cancelText || '取消',
        type: options.type || 'danger',
        onConfirm: () => {
          setDialog(prev => ({ ...prev, isOpen: false }));
          resolve(true);
        },
        onCancel: () => {
          setDialog(prev => ({ ...prev, isOpen: false }));
          resolve(false);
        }
      });
    });
  }, []);

  const handleConfirm = () => {
    if (dialog.onConfirm) {
      dialog.onConfirm();
    }
  };

  const handleCancel = () => {
    if (dialog.onCancel) {
      dialog.onCancel();
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCancel();
    }
  };

  return (
    <ConfirmDialogContext.Provider value={{ confirm }}>
      {children}
      
      {dialog.isOpen && createPortal(
        <div className="confirm-dialog-overlay" onClick={handleOverlayClick}>
          <div className={`confirm-dialog ${dialog.type}`}>
            <div className="confirm-dialog-header">
              <h3>{dialog.title}</h3>
            </div>

            <div className="confirm-dialog-body">
              <p>{dialog.message}</p>
            </div>

            <div className="confirm-dialog-footer">
              <button
                className="btn-cancel"
                onClick={handleCancel}
              >
                {dialog.cancelText}
              </button>
              <button
                className={`btn-confirm ${dialog.type}`}
                onClick={handleConfirm}
              >
                {dialog.confirmText}
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </ConfirmDialogContext.Provider>
  );
};

